import { createTheme } from "@mui/material/styles";
import { overrideComponents } from "./overrideComponents/components";

// A custom theme for this app
export let theme = createTheme({
  spacing: 6, // 8 is default
  palette: {
    primary: {
      main: "#08519c", // logo color: #0d628d
      light: "#1e78df",
      dark: "#08519c",
    },
    info: {
      main: "#fff"
    },
    text: {
      primary: "#000000" // Black
    },
    // secondary: {
    //   main: '#19857b',
    // },
    // error: {
    //   main: red.A400,
    // },
    success: {
      main: '#1DB954',
      light: '#81c784',
      dark: '#388e3c',
    },
    background: {
      default: "rgb(242, 245, 249)",
      //neutral: "#fdfdfd",
      //hover: 'rgba(13, 98, 141, 0.04)'
    },
    border: {
      main: "rgba(0, 0, 0, 0.08)",
      light: "#F5F5F5", // use hex values, not arbitrary color names
      dark: "#cfcfcf",
    }
  },
  zIndex: {},
});

declare module "@mui/material/styles" {
  interface Palette {
    border: {
      main: string;
      light: string;
      dark: string;
    };
  }
  interface PaletteOptions {
    border: {
      main: string;
      light: string;
      dark: string;
    };
  }
  // interface TypeBackground {
  //   neutral: string;
  // }
}

theme.components = overrideComponents(theme);
